// extracted by mini-css-extract-plugin
export default {"productDescription":"Wea-z","featuredDescription":"Xea-z","description":"Yea-z","more":"Zea-z","descriptionSku":"_ea-z"};